module.exports = __webpack_public_path__ + "images/43196f83088b5b0219b10ff1da3df7df-sia-icon-loader.svg";